<template>
  <form :data-vv-scope="parentScope">
    <div class="flex flex-col sm:flex-row">
      <div class="flex-1 sm:w-1/2 sm:pr-8 sm:flex-none mt-0">
        <label class="font-medium"
          ><span class="text-brand">*</span> Account Name</label
        >
        <input
          type="text"
          class="w-full border py-2 px-3 mt-2 rounded"
          v-model="form.account_name"
          v-validate="
            paymentType == 'direct-debit' ? 'required|max:32|min:3' : ''
          "
          name="account_name"
          tabindex="1"
          :class="{ 'border-red': errors.has(parentScope + '.account_name') }"
        />
        <div
          v-show="errors.has(parentScope + '.account_name')"
          class="text-red text-sm mt-2"
        >
          {{ errors.first(parentScope + ".account_name") }}
        </div>
      </div>
      <div class="flex-1 sm:w-1/2 mt-4 sm:mt-0 sm:flex-none">
        <label class="font-medium"
          ><span class="text-brand">*</span> Account Number</label
        >
        <input
          type="text"
          class="w-full border py-2 px-3 mt-2 rounded"
          v-model="form.account_number"
          v-validate="
            paymentType == 'direct-debit' ? 'required|numeric|min:4|max:10' : ''
          "
          name="account_number"
          tabindex="2"
          :class="{ 'border-red': errors.has(parentScope + '.account_number') }"
        />
        <div
          v-show="errors.has(parentScope + '.account_number')"
          class="text-red text-sm mt-2"
        >
          {{ errors.first(parentScope + ".account_number") }}
        </div>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row sm:mt-8">
      <div class="flex-1 sm:w-1/2 sm:pr-8 mt-4 sm:mt-0 sm:flex-none">
        <label class="font-medium"><span class="text-brand">*</span> BSB</label>
        <input
          type="text"
          class="w-full border py-2 px-3 mt-2 rounded"
          v-model="form.bsb"
          v-validate="paymentType == 'direct-debit' ? 'required|digits:6' : ''"
          name="bsb"
          tabindex="3"
          :class="{ 'border-red': errors.has(parentScope + '.bsb') }"
        />
        <div
          v-show="errors.has(parentScope + '.bsb')"
          class="text-red text-sm mt-2"
        >
          {{ errors.first(parentScope + ".bsb") }}
        </div>
      </div>
      <div class="flex-1 sm:w-1/2 mt-4 sm:mt-0 sm:flex-none">
        <label class="font-medium"
          ><span class="text-brand">*</span> Financial Institution</label
        >
        <input
          type="text"
          class="w-full border py-2 px-3 mt-2 rounded"
          v-model="form.financial_institution"
          v-validate="paymentType == 'direct-debit' ? 'required' : ''"
          name="financial_institution"
          tabindex="4"
          :class="{
            'border-red': errors.has(parentScope + '.financial_institution'),
          }"
        />
        <div
          v-show="errors.has(parentScope + '.financial_institution')"
          class="text-red text-sm mt-2"
        >
          {{ errors.first(parentScope + ".financial_institution") }}
        </div>
      </div>
    </div>

    <button type="submit" class="invisible"></button>
  </form>
</template>

<script>
export default {
  inject: ["$validator"],

  props: ["value", "payment-type", "parent-scope"],

  data() {
    return {
      form: _.cloneDeep(this.value),
    };
  },

  watch: {
    form: {
      deep: true,
      handler: function () {
        this.$emit("input", this.form);
      },
    },
    paymentType() {
      this.form.type = this.paymentType;
    },
  },
};
</script>

<style>
.multiselect__tags {
  min-height: 0px;
  display: block;
  padding: 6px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #dae4e9;
  background: #fff;
}
.multiselect__input {
  font-size: 16px;
}
</style>
